/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    id: 'taskDt',
    key: 'taskDt',
    width: 180,
    tip: '任务月度',
    label: '任务月度',
    format: 'yyyy-MM',
    slot: 'date'
  },
  {
    id: 'fullName',
    key: 'fullName',
    width: 180,
    tip: '项目参与人',
    label: '项目参与人',
    slot: 'input'
  },
  {
    id: 'phone',
    key: 'phone',
    width: 180,
    tip: '手机号',
    label: '手机号',
    slot: 'input'
  },
  {
    id: 'projectName',
    key: 'projectName',
    width: 180,
    tip: '项目名称',
    label: '项目名称',
    slot: 'input'
  }
];
